<h1 class="ao-heading-100">Track a Claim</h1>

<div class="formbox">
	<form [formGroup]="form" (ngSubmit)="trackClaim()" class="form-grid">
		<label for="claimNumber" class="form-grid-label label-with-hint">Claim Number:</label>
		<div class="input-hint-container">
			<input
				id="claimNumber"
				type="text"
				formControlName="claimNumber"
				mask="000-0000000-0000"
				[dropSpecialCharacters]="false"
				class="form-grid-input"
				[class.form-grid-input-error]="claimNumberControl.touched && claimNumberControl.invalid"
				[@inputError]="claimNumberControl.touched && claimNumberControl.invalid ? 'invalid' : 'valid'"
				aria-required="true"
				[attr.aria-invalid]="claimNumberControl.touched && claimNumberControl.invalid"
				[attr.aria-describedby]="
					claimNumberControl.touched && claimNumberControl.invalid ? 'claim-number-error-message' : undefined
				"
			/>
			<p class="hint-label">(xxx-xxxxxxx-xxxx)</p>
		</div>
		@if (claimNumberControl.touched && claimNumberControl.invalid) {
			@for (errorMessage of claimNumberControlErrors; track errorMessage) {
				<p id="claim-number-error-message" class="ao-form-text ao-error form-grid-error" @expandCollapse>
					{{ errorMessage }}
				</p>
			}
		}

		<label for="name" class="form-grid-label">Your Last Name, Company Name if Business:</label>
		<input
			id="name"
			type="text"
			formControlName="name"
			[maxlength]="128"
			class="form-grid-input"
			[class.form-grid-input-error]="nameControl.touched && nameControl.invalid"
			[@inputError]="nameControl.touched && nameControl.invalid ? 'invalid' : 'valid'"
			aria-required="true"
			[attr.aria-invalid]="nameControl.touched && nameControl.invalid"
			[attr.aria-describedby]="nameControl.touched && nameControl.invalid ? 'name-error-message' : undefined"
		/>
		@if (nameControl.touched && nameControl.invalid) {
			@for (errorMessage of nameControlErrors; track errorMessage) {
				<p id="name-error-message" class="ao-form-text ao-error form-grid-error" @expandCollapse>
					{{ errorMessage }}
				</p>
			}
		}

		<label for="phoneNumber" class="form-grid-label">Your Phone Number:</label>
		<input
			id="phoneNumber"
			type="tel"
			formControlName="phoneNumber"
			mask="(000) 000-0000"
			class="form-grid-input"
			[class.form-grid-input-error]="phoneNumberControl.touched && phoneNumberControl.invalid"
			[@inputError]="phoneNumberControl.touched && phoneNumberControl.invalid ? 'invalid' : 'valid'"
			aria-required="true"
			[attr.aria-invalid]="phoneNumberControl.touched && phoneNumberControl.invalid"
			[attr.aria-describedby]="
				phoneNumberControl.touched && phoneNumberControl.invalid ? 'phone-number-error-message' : undefined
			"
		/>
		@if (phoneNumberControl.touched && phoneNumberControl.invalid) {
			@for (errorMessage of phoneNumberControlErrors; track errorMessage) {
				<p id="phone-number-error-message" class="ao-form-text ao-error form-grid-error" @expandCollapse>
					{{ errorMessage }}
				</p>
			}
		}

		<!-- List of validation messages only read by a screen reader (not visible) -->
		<div class="sr-only" role="alert">
			@if (validationFailed) {
				Attempt to track a claim failed due to the following validation errors:
				<ul>
					@for (errorMessage of claimNumberControlErrors; track errorMessage) {
						<li>Claim Number: {{ errorMessage }}</li>
					}
					@for (errorMessage of nameControlErrors; track errorMessage) {
						<li>Last Name or Company: {{ errorMessage }}</li>
					}
					@for (errorMessage of phoneNumberControlErrors; track errorMessage) {
						<li>Phone Number: {{ errorMessage }}</li>
					}
				</ul>
			}
		</div>

		<div id="button-group" aria-live="polite">
			<button type="submit" class="ao-button-primary">Track</button>
			@if (loading()) {
				<p class="sr-only">Looking for your claim.</p>
				<span class="ao-spinner-32" @fadeInOut></span>
			}
		</div>
	</form>
</div>
